import { useUser } from "@oceanjs/core";

/**
 * extract role from user 
 */
export function useRole(): string {
  const user = useUser();
  
  var role = 'ROLE_EHPC_READ';
  if (user !== null && user.authorities.length >= 1) {
    role = user.authorities[0].authority;
  }

  return role;

}
